
<div>
  <div class="subnavbackground">
    <SavedSearches 
      application="tv-analys" 
      :tabName="$route.meta.tabQuery" 
      :currentFilters="$store.getters[`get${$route.meta.tabQuery}Query`]"
      :isExpanded="expandSavedSearchesSidebar"
      @close="$store.commit('setExpandSavedSearchesSidebar', false)"
    />
    <b-row v-if="obsMessage" class="obs-message-row">
      <p class="obsText">{{ obsMessage }}</p>
    </b-row>
    <b-row class="bottomheader mr-0">
      <!-- Left content -->
      <div class="d-flex align-items-center info-tooltip-container">
        <div class="this-tool-container">
          <div id="versionTooltip" class="this-tool-icon-container">
            <img class="this-tool-icon" :src="blueAppIconPath" alt="" />
          </div>
          <span v-if="userInternalText()" class="userinternaltext">
            {{ userInternalText() }} &#x1F441;
          </span>
        </div>
        <b-tooltip
          v-if="
            SSASMessage != null || this.config_CurrentClientVersion != null
          "
          target="versionTooltip"
          boundary="viewport"
          html
          triggers="hover"
          custom-class="infoTooltip"
        >
          <p>Client version: {{ this.config_CurrentClientVersion }}</p>
          <p>API version: {{ SSASMessage.version }}</p>
          <p>Model: {{ SSASMessage.linkedSSAS }}</p>
          <p>Last SSAS processing: {{ SSASMessage.lastProcessed }}</p>
          <p>Last panel day: {{ SSASMessage.latestDay }}</p>
          <p>First publish date: {{ SSASMessage.publishedFromDate }}</p>
          <p>Last publish date: {{ SSASMessage.publishedToDate }}</p>
          <p>Last ad log data: {{ SSASMessage.metadataAdToDate }}</p>
          <p>
            Last program log data: {{ SSASMessage.metadataProgramToDate }}
          </p>
          <p>
            Streaming published:
            {{ SSASMessage.streamingPublishedFromDate }}-{{
              SSASMessage.streamingPublishedToDate
            }}
          </p>
        </b-tooltip>
      </div>
      <!-- Center content -->
      <div
        v-if="$store.getters.getCurrentApp !== 'video-in-home'"
        class="center-container"
      >
        <div class="absolute-center">
          <router-link
            v-if="
              this.$store.state.systemInfo.lightAccess ||
                this.$store.state.systemInfo.fullAccess
            "
            to="/toplist"
            >Top list</router-link
          >
          <router-link
            v-if="this.$store.state.systemInfo.fullAccess"
            to="/programs"
            >Program</router-link
          >
          <router-link
            v-if="
              this.$store.state.systemInfo.fullAccess ||
                this.$store.state.systemInfo.advertiserAccess
            "
            to="/campaigns"
            >Ad</router-link
          >
          <router-link
            v-if="this.$store.state.systemInfo.fullAccess"
            to="/channels"
            >Channel</router-link
          >
        </div>
      </div>
      <!-- Right content -->
      <div>
        <div class="d-flex right-content right" v-if="showButton()">
          <b-button 
            class="btn-xs" 
            variant="primary" 
            id="tooltip-target-1" 
            @click="$store.commit('setExpandSavedSearchesSidebar', true)" 
            v-if="showSaveSearchButton"
          >
            <i class="bi bi-floppy"></i>
          </b-button>
          <b-tooltip target="tooltip-target-1" triggers="hover">
            Save/load template
          </b-tooltip>
          <b-button
            class="btn-xs mx-2"
            variant="primary"
            @click="handleToggleInformationSidebarClick"
            id="infoButton"
          >
            <b-icon icon="info-circle"></b-icon>
          </b-button>
          <b-tooltip
            target="infoButton"
            triggers="hover"
            placement="top"
          >
            View information log
          </b-tooltip>

          <b-button
            @click="openManual"
            class="btn-xs"
            variant="info"
            id="bookButton"
          >
            <b-icon icon="book"></b-icon>
            <span></span>
          </b-button>
          <b-tooltip target="bookButton" triggers="hover" placement="top">
            Read user manual
          </b-tooltip>
        </div>
      </div>
    </b-row>
  </div>
  <b-sidebar
    right
    id="info-sidebar"
    title="Information log"
    shadow
  >
    <div class="px-3 py-2">
      <p class="messageBox" v-html="dataLogMessage"></p>
    </div>
  </b-sidebar>
</div>
